export default class CartaId {
	id: number;

	workflowInstanceId?: number;

	cartaAppId!: string;

	cartaAppName!: string;

	comment!: string;

	constructor(objOrAppName: any, appId?: string, comment?: string) {
		if (typeof objOrAppName === 'object') {
			Object.assign(this, objOrAppName);
		} else if (typeof objOrAppName === 'string' && appId) {
			this.cartaAppName = objOrAppName;
			this.cartaAppId = appId;
			this.comment = comment || '';
		}
	}
}